import { ClickAwayListener, Tooltip } from "@mui/material";
import { useCallback, useState } from "react";
import { HypeIcon } from "../HypeIcon";

export type THTooltipSuffix = {
  triggerIcon?: HypeIconName;
  triggerIconColor?: THypeColors;
  description: string;
};

export const HTooltipSuffix = (props: THTooltipSuffix) => {
  const {
    triggerIcon = "icon_check-o",
    triggerIconColor = "secondary.main",
    description,
  } = props;
  const [open, setOpen] = useState(false);

  const handleTooltipClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleTooltipOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        className="HTooltipSuffix"
        open={open}
        title={description}
        onClose={handleTooltipClose}
        placement="top-end"
        arrow
        leaveDelay={10000}
        leaveTouchDelay={10000}
        slotProps={{
          popper: {
            disablePortal: true,
            modifiers: [{ name: "offset", options: { offset: [0, -10] } }],
          },
        }}
      >
        <span
          title={description}
          onClick={handleTooltipOpen}
          style={{ cursor: "pointer" }}
        >
          <HypeIcon name={triggerIcon} size={20} color={triggerIconColor} />
        </span>
      </Tooltip>
    </ClickAwayListener>
  );
};
